import { render, staticRenderFns } from "./MyPageContentTemplate.vue?vue&type=template&id=2b468d26&scoped=true&"
import script from "./MyPageContentTemplate.vue?vue&type=script&lang=ts&"
export * from "./MyPageContentTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b468d26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
